export const faqs = [
  {
    title: " What is 2M Seamless",
    content: `Placeholder content for this accordion, which is intended to demonstrate the 
    .accordion-flush class. This is the first item's accordion body.`,
    category: "general",
  },
  {
    title: "Lorem ipsum dolor sit amet, consectetuer adipiscing",
    content: `Placeholder content for this accordion, which is intended to demonstrate the 
    .accordion-flush class. This is the first item's accordion body.`,
    category: "general",
  },
  {
    title: "Lorem ipsum dolor sit amet, consectetuer adipiscing",
    content: `Placeholder content for this accordion, which is intended to demonstrate the 
    .accordion-flush class. This is the second item's accordion body. Let's imagine this being 
    filled with some actual content.`,
    category: "general",
  },
  {
    title: "Lorem ipsum dolor sit amet, consectetuer adipiscing",
    content: `Placeholder content for this accordion, which is intended to
        demonstrate the <code>.accordion-flush</code> class. This is the
        third item's accordion body. Nothing more exciting happening here in
        terms of content, but just filling up the space to make it look, at
        least at first glance, a bit more representative of how this would
        look in a real-world application.`,
    category: "tailoring",
  },
  {
    title: "Lorem ipsum dolor sit amet, consectetuer adipiscing",
    content: `Placeholder content for this accordion, which is intended to
        demonstrate the <code>.accordion-flush</code> class. This is the
        third item's accordion body. Nothing more exciting happening here in
        terms of content, but just filling up the space to make it look, at
        least at first glance, a bit more representative of how this would
        look in a real-world application.`,
    category: "tailoring",
  },
  {
    title: "Lorem ipsum dolor sit amet, consectetuer adipiscing",
    content: `Placeholder content for this accordion, which is intended to demonstrate the 
    .accordion-flush class. This is the first item's accordion body.`,
    category: "tailoring",
  },

  {
    title: "Lorem ipsum dolor sit amet, consectetuer adipiscing",
    content: `Placeholder content for this accordion, which is intended to
        demonstrate the <code>.accordion-flush</code> class. This is the
        third item's accordion body. Nothing more exciting happening here in
        terms of content, but just filling up the space to make it look, at
        least at first glance, a bit more representative of how this would
        look in a real-world application.`,
    category: "laundry",
  },
  {
    title: "Lorem ipsum dolor sit amet, consectetuer adipiscing",
    content: `Placeholder content for this accordion, which is intended to
        demonstrate the <code>.accordion-flush</code> class. This is the
        third item's accordion body. Nothing more exciting happening here in
        terms of content, but just filling up the space to make it look, at
        least at first glance, a bit more representative of how this would
        look in a real-world application.`,
    category: "laundry",
  },
  {
    title: "Lorem ipsum dolor sit amet, consectetuer adipiscing",
    content: `Placeholder content for this accordion, which is intended to demonstrate the 
    .accordion-flush class. This is the first item's accordion body.`,
    category: "laundry",
  },
];
